// extracted by mini-css-extract-plugin
export default {"artistPills":"SpotlightArtistPills_artistPills__+EYmf"};